import React from 'react';
import { motion } from 'framer-motion';
// Placeholder import, we'll use a custom button
export function Navigation() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[#0a0a0a]/80 backdrop-blur-md" data-id="element-109">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4" data-id="element-110">
        <div className="text-sm font-bold tracking-tight text-white md:text-base" data-id="element-111">
          Shadowban Survival Kit
        </div>
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="rounded-full bg-amber-500 px-4 py-2 text-sm font-bold text-black transition-transform hover:scale-105 active:scale-95" data-id="element-112">
          Descargar Kit — <span className="line-through opacity-70" data-id="element-113">$19</span>{' '}
          $6.36
        </button>
      </div>
    </motion.nav>;
}